import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { Collection, ModelWithForm, WhenLoaded, WhenModel, WhenModelValue } from '@morningtrain/react-resources'
import { RouteParameterFilter, StaticFilter } from '@morningtrain/react-filters'
import { GlobalDepartmentFilter, SelectedDepartmentFilter } from 'support/filters'
import ModelValueTitle from 'widgets/ModelValueTitle'
import * as Displays from 'support/displays'
import SupplierDepartmentCategories from 'pages/app/inventory/supplier/SupplierDepartmentCategories'
import * as Icons from 'ui/icons'
import { Link } from '@morningtrain/react-navigation'
import * as Fields from 'support/fields'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import { Fieldset } from 'layouts'

export default function Departments () {
  return (
    <AdminPage withGlobalDepartmentFilter={false}>
      <Translator namespace='inventory.supplier'>
        <ModelWithForm resourceName='inventory.supplier_department' operationName='find' autoFetch={false}>
          <RouteParameterFilter name='inventory_supplier' />
          <SelectedDepartmentFilter />

          <ModelValueTitle name='name' display={false} />

          <UI.PageHeader title={(
            <UI.WithSubtitle subtitle={<Translation name='departments_subtitle' data={{ department: 'model:department.name' }} />}>
              <Displays.Text name='supplier.name' />
            </UI.WithSubtitle>
          )}
          >
            <UI.ButtonWrap>
              <Link
                route='app.inventory.supplier.edit'
                parameters={{ inventory_supplier: 'model:inventory_supplier_id' }}
              >
                <UI.Button>
                  <Icons.ArrowLeft className='mr-2' />
                  <span><Translation name='generic.back' /></span>
                </UI.Button>
              </Link>
              <GlobalDepartmentFilter />
              <WhenModel>
                <UI.SubmitButton>
                  <Translation name='generic.save' />
                </UI.SubmitButton>
              </WhenModel>
            </UI.ButtonWrap>
          </UI.PageHeader>

          <WhenModel>

            <UI.CardGroup>
              <UI.Card>
                <Fieldset cols={3}>
                  <Fields.Input
                    name='customer_number'
                    label={<Translation name='fields.customer_number.label' />}
                  />
                  <Fields.Input
                    name='minimum_order_amount'
                    label={<Translation name='fields.minimum_order_amount.label' />}
                    type='number'
                  />
                  <Fields.TabsField
                    name='should_notify_about_late_order'
                    enum='boolean_status'
                    defaultValue={0}
                    label={<Translation name='fields.should_notify_about_late_order.label' />}
                  />
                  <UpdateModelOnChange name='override_list' modify={v => parseInt(v) === 1}>
                    <Fields.TabsField
                      name='override_list'
                      enum='boolean_status'
                      defaultValue={0}
                      label={<Translation name='fields.override_list.label' />}
                    />
                  </UpdateModelOnChange>
                </Fieldset>
              </UI.Card>

              <WhenModelValue name='override_list' condition>
                <Collection resourceName='inventory.category' operationName='index'>
                  <RouteParameterFilter name='inventory_supplier' />
                  <StaticFilter name='with_chosen_items' value />
                  <SupplierDepartmentCategories />
                </Collection>
              </WhenModelValue>
            </UI.CardGroup>
          </WhenModel>

        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
